export default function binderTabIsDirty(tab) {
	return tab.dirty === true || (tab.clientId !== null && tab.clientId !== undefined);
}
